// extracted by mini-css-extract-plugin
export default {"nav-container":"styles_nav-container__jKz-2","logo":"styles_logo__tequH","header-link":"styles_header-link__SDs5P","active":"styles_active__L21OH"};